/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TryRouteImport } from './routes/try'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UpgradeSuccessRouteImport } from './routes/upgrade.success'
import { Route as ShareGoalIdRouteImport } from './routes/share.$goalId'
import { Route as OnboardingPaywallRouteImport } from './routes/onboarding.paywall'
import { Route as OauthConsentRouteImport } from './routes/oauth.consent'
import { Route as OauthAuthorizeRouteImport } from './routes/oauth.authorize'
import { Route as GoalsNewRouteImport } from './routes/goals.new'
import { Route as GoalsGoalIdRouteImport } from './routes/goals.$goalId'
import { Route as CTokenRouteImport } from './routes/c.$token'
import { Route as AuthSignupRouteImport } from './routes/auth.signup'
import { Route as AuthResetPasswordRouteImport } from './routes/auth.reset-password'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as AuthGoogleOnetapRouteImport } from './routes/auth.google-onetap'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth.forgot-password'
import { Route as AuthCheckEmailRouteImport } from './routes/auth.check-email'
import { Route as AuthenticatedVoiceRouteImport } from './routes/_authenticated.voice'
import { Route as AuthenticatedUpcomingRouteImport } from './routes/_authenticated.upcoming'
import { Route as AuthenticatedTodayRouteImport } from './routes/_authenticated.today'
import { Route as AuthenticatedStatsRouteImport } from './routes/_authenticated.stats'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated.settings'
import { Route as AuthenticatedReviewRouteImport } from './routes/_authenticated.review'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated.notifications'
import { Route as AuthenticatedMomentumRouteImport } from './routes/_authenticated.momentum'
import { Route as AuthenticatedLeaderboardRouteImport } from './routes/_authenticated.leaderboard'
import { Route as AuthenticatedJournalRouteImport } from './routes/_authenticated.journal'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated.inbox'
import { Route as AuthenticatedExploreRouteImport } from './routes/_authenticated.explore'
import { Route as AuthenticatedEverydayRouteImport } from './routes/_authenticated.everyday'
import { Route as AuthenticatedDiscoverRouteImport } from './routes/_authenticated.discover'
import { Route as GoalsNewIndexRouteImport } from './routes/goals.new.index'
import { Route as AuthenticatedTemplatesIndexRouteImport } from './routes/_authenticated.templates.index'
import { Route as AuthenticatedGrovesIndexRouteImport } from './routes/_authenticated.groves.index'
import { Route as AuthenticatedGoalsIndexRouteImport } from './routes/_authenticated.goals.index'
import { Route as AuthenticatedCoachingIndexRouteImport } from './routes/_authenticated.coaching.index'
import { Route as GrovesRequestSlugRouteImport } from './routes/groves.request.$slug'
import { Route as GrovesJoinCodeRouteImport } from './routes/groves.join.$code'
import { Route as GoalsNewQuestionsRouteImport } from './routes/goals.new.questions'
import { Route as GoalsNewPreviewRouteImport } from './routes/goals.new.preview'
import { Route as ApiInstagramCallbackRouteImport } from './routes/api.instagram.callback'
import { Route as ApiGmailCallbackRouteImport } from './routes/api.gmail.callback'
import { Route as ApiFitnessCallbackRouteImport } from './routes/api.fitness.callback'
import { Route as ApiCalendarCallbackRouteImport } from './routes/api.calendar.callback'
import { Route as AuthenticatedTemplatesTemplateIdRouteImport } from './routes/_authenticated.templates.$templateId'
import { Route as AuthenticatedOnboardingUserProfileRouteImport } from './routes/_authenticated.onboarding.user-profile'
import { Route as AuthenticatedOnboardingIntakeRouteImport } from './routes/_authenticated.onboarding.intake'
import { Route as AuthenticatedHabitsHabitIdRouteImport } from './routes/_authenticated.habits.$habitId'
import { Route as AuthenticatedGrovesGroveIdRouteImport } from './routes/_authenticated.groves.$groveId'
import { Route as AuthenticatedCoachingPlansRouteImport } from './routes/_authenticated.coaching.plans'
import { Route as AuthenticatedCoachingLibraryRouteImport } from './routes/_authenticated.coaching.library'
import { Route as AuthenticatedCoachingClientIdRouteImport } from './routes/_authenticated.coaching.$clientId'
import { Route as AuthenticatedActionStartStoryRouteImport } from './routes/_authenticated.action.start-story'
import { Route as AuthenticatedActionFollowRouteImport } from './routes/_authenticated.action.follow'
import { Route as AuthenticatedFriendsGoalsGoalIdRouteImport } from './routes/_authenticated.friends.goals.$goalId'

const TryRoute = TryRouteImport.update({
  id: '/try',
  path: '/try',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeSuccessRoute = UpgradeSuccessRouteImport.update({
  id: '/upgrade/success',
  path: '/upgrade/success',
  getParentRoute: () => rootRouteImport,
} as any)
const ShareGoalIdRoute = ShareGoalIdRouteImport.update({
  id: '/share/$goalId',
  path: '/share/$goalId',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingPaywallRoute = OnboardingPaywallRouteImport.update({
  id: '/onboarding/paywall',
  path: '/onboarding/paywall',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth/consent',
  path: '/oauth/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthAuthorizeRoute = OauthAuthorizeRouteImport.update({
  id: '/oauth/authorize',
  path: '/oauth/authorize',
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsNewRoute = GoalsNewRouteImport.update({
  id: '/goals/new',
  path: '/goals/new',
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsGoalIdRoute = GoalsGoalIdRouteImport.update({
  id: '/goals/$goalId',
  path: '/goals/$goalId',
  getParentRoute: () => rootRouteImport,
} as any)
const CTokenRoute = CTokenRouteImport.update({
  id: '/c/$token',
  path: '/c/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGoogleOnetapRoute = AuthGoogleOnetapRouteImport.update({
  id: '/google-onetap',
  path: '/google-onetap',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCheckEmailRoute = AuthCheckEmailRouteImport.update({
  id: '/check-email',
  path: '/check-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedVoiceRoute = AuthenticatedVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUpcomingRoute = AuthenticatedUpcomingRouteImport.update({
  id: '/upcoming',
  path: '/upcoming',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTodayRoute = AuthenticatedTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedStatsRoute = AuthenticatedStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReviewRoute = AuthenticatedReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMomentumRoute = AuthenticatedMomentumRouteImport.update({
  id: '/momentum',
  path: '/momentum',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedLeaderboardRoute =
  AuthenticatedLeaderboardRouteImport.update({
    id: '/leaderboard',
    path: '/leaderboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedJournalRoute = AuthenticatedJournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedExploreRoute = AuthenticatedExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedEverydayRoute = AuthenticatedEverydayRouteImport.update({
  id: '/everyday',
  path: '/everyday',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDiscoverRoute = AuthenticatedDiscoverRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const GoalsNewIndexRoute = GoalsNewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => GoalsNewRoute,
} as any)
const AuthenticatedTemplatesIndexRoute =
  AuthenticatedTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGrovesIndexRoute =
  AuthenticatedGrovesIndexRouteImport.update({
    id: '/groves/',
    path: '/groves/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGoalsIndexRoute = AuthenticatedGoalsIndexRouteImport.update({
  id: '/goals/',
  path: '/goals/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCoachingIndexRoute =
  AuthenticatedCoachingIndexRouteImport.update({
    id: '/coaching/',
    path: '/coaching/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const GrovesRequestSlugRoute = GrovesRequestSlugRouteImport.update({
  id: '/groves/request/$slug',
  path: '/groves/request/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const GrovesJoinCodeRoute = GrovesJoinCodeRouteImport.update({
  id: '/groves/join/$code',
  path: '/groves/join/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const GoalsNewQuestionsRoute = GoalsNewQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => GoalsNewRoute,
} as any)
const GoalsNewPreviewRoute = GoalsNewPreviewRouteImport.update({
  id: '/preview',
  path: '/preview',
  getParentRoute: () => GoalsNewRoute,
} as any)
const ApiInstagramCallbackRoute = ApiInstagramCallbackRouteImport.update({
  id: '/api/instagram/callback',
  path: '/api/instagram/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiGmailCallbackRoute = ApiGmailCallbackRouteImport.update({
  id: '/api/gmail/callback',
  path: '/api/gmail/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiFitnessCallbackRoute = ApiFitnessCallbackRouteImport.update({
  id: '/api/fitness/callback',
  path: '/api/fitness/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const ApiCalendarCallbackRoute = ApiCalendarCallbackRouteImport.update({
  id: '/api/calendar/callback',
  path: '/api/calendar/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTemplatesTemplateIdRoute =
  AuthenticatedTemplatesTemplateIdRouteImport.update({
    id: '/templates/$templateId',
    path: '/templates/$templateId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOnboardingUserProfileRoute =
  AuthenticatedOnboardingUserProfileRouteImport.update({
    id: '/onboarding/user-profile',
    path: '/onboarding/user-profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOnboardingIntakeRoute =
  AuthenticatedOnboardingIntakeRouteImport.update({
    id: '/onboarding/intake',
    path: '/onboarding/intake',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHabitsHabitIdRoute =
  AuthenticatedHabitsHabitIdRouteImport.update({
    id: '/habits/$habitId',
    path: '/habits/$habitId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedGrovesGroveIdRoute =
  AuthenticatedGrovesGroveIdRouteImport.update({
    id: '/groves/$groveId',
    path: '/groves/$groveId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoachingPlansRoute =
  AuthenticatedCoachingPlansRouteImport.update({
    id: '/coaching/plans',
    path: '/coaching/plans',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoachingLibraryRoute =
  AuthenticatedCoachingLibraryRouteImport.update({
    id: '/coaching/library',
    path: '/coaching/library',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCoachingClientIdRoute =
  AuthenticatedCoachingClientIdRouteImport.update({
    id: '/coaching/$clientId',
    path: '/coaching/$clientId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActionStartStoryRoute =
  AuthenticatedActionStartStoryRouteImport.update({
    id: '/action/start-story',
    path: '/action/start-story',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedActionFollowRoute =
  AuthenticatedActionFollowRouteImport.update({
    id: '/action/follow',
    path: '/action/follow',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFriendsGoalsGoalIdRoute =
  AuthenticatedFriendsGoalsGoalIdRouteImport.update({
    id: '/friends/goals/$goalId',
    path: '/friends/goals/$goalId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/try': typeof TryRoute
  '/discover': typeof AuthenticatedDiscoverRoute
  '/everyday': typeof AuthenticatedEverydayRoute
  '/explore': typeof AuthenticatedExploreRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/journal': typeof AuthenticatedJournalRoute
  '/leaderboard': typeof AuthenticatedLeaderboardRoute
  '/momentum': typeof AuthenticatedMomentumRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/review': typeof AuthenticatedReviewRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stats': typeof AuthenticatedStatsRoute
  '/today': typeof AuthenticatedTodayRoute
  '/upcoming': typeof AuthenticatedUpcomingRoute
  '/voice': typeof AuthenticatedVoiceRoute
  '/auth/check-email': typeof AuthCheckEmailRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/google-onetap': typeof AuthGoogleOnetapRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/c/$token': typeof CTokenRoute
  '/goals/$goalId': typeof GoalsGoalIdRoute
  '/goals/new': typeof GoalsNewRouteWithChildren
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/paywall': typeof OnboardingPaywallRoute
  '/share/$goalId': typeof ShareGoalIdRoute
  '/upgrade/success': typeof UpgradeSuccessRoute
  '/action/follow': typeof AuthenticatedActionFollowRoute
  '/action/start-story': typeof AuthenticatedActionStartStoryRoute
  '/coaching/$clientId': typeof AuthenticatedCoachingClientIdRoute
  '/coaching/library': typeof AuthenticatedCoachingLibraryRoute
  '/coaching/plans': typeof AuthenticatedCoachingPlansRoute
  '/groves/$groveId': typeof AuthenticatedGrovesGroveIdRoute
  '/habits/$habitId': typeof AuthenticatedHabitsHabitIdRoute
  '/onboarding/intake': typeof AuthenticatedOnboardingIntakeRoute
  '/onboarding/user-profile': typeof AuthenticatedOnboardingUserProfileRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/api/calendar/callback': typeof ApiCalendarCallbackRoute
  '/api/fitness/callback': typeof ApiFitnessCallbackRoute
  '/api/gmail/callback': typeof ApiGmailCallbackRoute
  '/api/instagram/callback': typeof ApiInstagramCallbackRoute
  '/goals/new/preview': typeof GoalsNewPreviewRoute
  '/goals/new/questions': typeof GoalsNewQuestionsRoute
  '/groves/join/$code': typeof GrovesJoinCodeRoute
  '/groves/request/$slug': typeof GrovesRequestSlugRoute
  '/coaching/': typeof AuthenticatedCoachingIndexRoute
  '/goals/': typeof AuthenticatedGoalsIndexRoute
  '/groves/': typeof AuthenticatedGrovesIndexRoute
  '/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/goals/new/': typeof GoalsNewIndexRoute
  '/friends/goals/$goalId': typeof AuthenticatedFriendsGoalsGoalIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/try': typeof TryRoute
  '/discover': typeof AuthenticatedDiscoverRoute
  '/everyday': typeof AuthenticatedEverydayRoute
  '/explore': typeof AuthenticatedExploreRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/journal': typeof AuthenticatedJournalRoute
  '/leaderboard': typeof AuthenticatedLeaderboardRoute
  '/momentum': typeof AuthenticatedMomentumRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/review': typeof AuthenticatedReviewRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/stats': typeof AuthenticatedStatsRoute
  '/today': typeof AuthenticatedTodayRoute
  '/upcoming': typeof AuthenticatedUpcomingRoute
  '/voice': typeof AuthenticatedVoiceRoute
  '/auth/check-email': typeof AuthCheckEmailRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/google-onetap': typeof AuthGoogleOnetapRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/c/$token': typeof CTokenRoute
  '/goals/$goalId': typeof GoalsGoalIdRoute
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/paywall': typeof OnboardingPaywallRoute
  '/share/$goalId': typeof ShareGoalIdRoute
  '/upgrade/success': typeof UpgradeSuccessRoute
  '/action/follow': typeof AuthenticatedActionFollowRoute
  '/action/start-story': typeof AuthenticatedActionStartStoryRoute
  '/coaching/$clientId': typeof AuthenticatedCoachingClientIdRoute
  '/coaching/library': typeof AuthenticatedCoachingLibraryRoute
  '/coaching/plans': typeof AuthenticatedCoachingPlansRoute
  '/groves/$groveId': typeof AuthenticatedGrovesGroveIdRoute
  '/habits/$habitId': typeof AuthenticatedHabitsHabitIdRoute
  '/onboarding/intake': typeof AuthenticatedOnboardingIntakeRoute
  '/onboarding/user-profile': typeof AuthenticatedOnboardingUserProfileRoute
  '/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/api/calendar/callback': typeof ApiCalendarCallbackRoute
  '/api/fitness/callback': typeof ApiFitnessCallbackRoute
  '/api/gmail/callback': typeof ApiGmailCallbackRoute
  '/api/instagram/callback': typeof ApiInstagramCallbackRoute
  '/goals/new/preview': typeof GoalsNewPreviewRoute
  '/goals/new/questions': typeof GoalsNewQuestionsRoute
  '/groves/join/$code': typeof GrovesJoinCodeRoute
  '/groves/request/$slug': typeof GrovesRequestSlugRoute
  '/coaching': typeof AuthenticatedCoachingIndexRoute
  '/goals': typeof AuthenticatedGoalsIndexRoute
  '/groves': typeof AuthenticatedGrovesIndexRoute
  '/templates': typeof AuthenticatedTemplatesIndexRoute
  '/goals/new': typeof GoalsNewIndexRoute
  '/friends/goals/$goalId': typeof AuthenticatedFriendsGoalsGoalIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/try': typeof TryRoute
  '/_authenticated/discover': typeof AuthenticatedDiscoverRoute
  '/_authenticated/everyday': typeof AuthenticatedEverydayRoute
  '/_authenticated/explore': typeof AuthenticatedExploreRoute
  '/_authenticated/inbox': typeof AuthenticatedInboxRoute
  '/_authenticated/journal': typeof AuthenticatedJournalRoute
  '/_authenticated/leaderboard': typeof AuthenticatedLeaderboardRoute
  '/_authenticated/momentum': typeof AuthenticatedMomentumRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/review': typeof AuthenticatedReviewRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/stats': typeof AuthenticatedStatsRoute
  '/_authenticated/today': typeof AuthenticatedTodayRoute
  '/_authenticated/upcoming': typeof AuthenticatedUpcomingRoute
  '/_authenticated/voice': typeof AuthenticatedVoiceRoute
  '/auth/check-email': typeof AuthCheckEmailRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/google-onetap': typeof AuthGoogleOnetapRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/signup': typeof AuthSignupRoute
  '/c/$token': typeof CTokenRoute
  '/goals/$goalId': typeof GoalsGoalIdRoute
  '/goals/new': typeof GoalsNewRouteWithChildren
  '/oauth/authorize': typeof OauthAuthorizeRoute
  '/oauth/consent': typeof OauthConsentRoute
  '/onboarding/paywall': typeof OnboardingPaywallRoute
  '/share/$goalId': typeof ShareGoalIdRoute
  '/upgrade/success': typeof UpgradeSuccessRoute
  '/_authenticated/action/follow': typeof AuthenticatedActionFollowRoute
  '/_authenticated/action/start-story': typeof AuthenticatedActionStartStoryRoute
  '/_authenticated/coaching/$clientId': typeof AuthenticatedCoachingClientIdRoute
  '/_authenticated/coaching/library': typeof AuthenticatedCoachingLibraryRoute
  '/_authenticated/coaching/plans': typeof AuthenticatedCoachingPlansRoute
  '/_authenticated/groves/$groveId': typeof AuthenticatedGrovesGroveIdRoute
  '/_authenticated/habits/$habitId': typeof AuthenticatedHabitsHabitIdRoute
  '/_authenticated/onboarding/intake': typeof AuthenticatedOnboardingIntakeRoute
  '/_authenticated/onboarding/user-profile': typeof AuthenticatedOnboardingUserProfileRoute
  '/_authenticated/templates/$templateId': typeof AuthenticatedTemplatesTemplateIdRoute
  '/api/calendar/callback': typeof ApiCalendarCallbackRoute
  '/api/fitness/callback': typeof ApiFitnessCallbackRoute
  '/api/gmail/callback': typeof ApiGmailCallbackRoute
  '/api/instagram/callback': typeof ApiInstagramCallbackRoute
  '/goals/new/preview': typeof GoalsNewPreviewRoute
  '/goals/new/questions': typeof GoalsNewQuestionsRoute
  '/groves/join/$code': typeof GrovesJoinCodeRoute
  '/groves/request/$slug': typeof GrovesRequestSlugRoute
  '/_authenticated/coaching/': typeof AuthenticatedCoachingIndexRoute
  '/_authenticated/goals/': typeof AuthenticatedGoalsIndexRoute
  '/_authenticated/groves/': typeof AuthenticatedGrovesIndexRoute
  '/_authenticated/templates/': typeof AuthenticatedTemplatesIndexRoute
  '/goals/new/': typeof GoalsNewIndexRoute
  '/_authenticated/friends/goals/$goalId': typeof AuthenticatedFriendsGoalsGoalIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/try'
    | '/discover'
    | '/everyday'
    | '/explore'
    | '/inbox'
    | '/journal'
    | '/leaderboard'
    | '/momentum'
    | '/notifications'
    | '/review'
    | '/settings'
    | '/stats'
    | '/today'
    | '/upcoming'
    | '/voice'
    | '/auth/check-email'
    | '/auth/forgot-password'
    | '/auth/google-onetap'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/c/$token'
    | '/goals/$goalId'
    | '/goals/new'
    | '/oauth/authorize'
    | '/oauth/consent'
    | '/onboarding/paywall'
    | '/share/$goalId'
    | '/upgrade/success'
    | '/action/follow'
    | '/action/start-story'
    | '/coaching/$clientId'
    | '/coaching/library'
    | '/coaching/plans'
    | '/groves/$groveId'
    | '/habits/$habitId'
    | '/onboarding/intake'
    | '/onboarding/user-profile'
    | '/templates/$templateId'
    | '/api/calendar/callback'
    | '/api/fitness/callback'
    | '/api/gmail/callback'
    | '/api/instagram/callback'
    | '/goals/new/preview'
    | '/goals/new/questions'
    | '/groves/join/$code'
    | '/groves/request/$slug'
    | '/coaching/'
    | '/goals/'
    | '/groves/'
    | '/templates/'
    | '/goals/new/'
    | '/friends/goals/$goalId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/try'
    | '/discover'
    | '/everyday'
    | '/explore'
    | '/inbox'
    | '/journal'
    | '/leaderboard'
    | '/momentum'
    | '/notifications'
    | '/review'
    | '/settings'
    | '/stats'
    | '/today'
    | '/upcoming'
    | '/voice'
    | '/auth/check-email'
    | '/auth/forgot-password'
    | '/auth/google-onetap'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/c/$token'
    | '/goals/$goalId'
    | '/oauth/authorize'
    | '/oauth/consent'
    | '/onboarding/paywall'
    | '/share/$goalId'
    | '/upgrade/success'
    | '/action/follow'
    | '/action/start-story'
    | '/coaching/$clientId'
    | '/coaching/library'
    | '/coaching/plans'
    | '/groves/$groveId'
    | '/habits/$habitId'
    | '/onboarding/intake'
    | '/onboarding/user-profile'
    | '/templates/$templateId'
    | '/api/calendar/callback'
    | '/api/fitness/callback'
    | '/api/gmail/callback'
    | '/api/instagram/callback'
    | '/goals/new/preview'
    | '/goals/new/questions'
    | '/groves/join/$code'
    | '/groves/request/$slug'
    | '/coaching'
    | '/goals'
    | '/groves'
    | '/templates'
    | '/goals/new'
    | '/friends/goals/$goalId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/auth'
    | '/try'
    | '/_authenticated/discover'
    | '/_authenticated/everyday'
    | '/_authenticated/explore'
    | '/_authenticated/inbox'
    | '/_authenticated/journal'
    | '/_authenticated/leaderboard'
    | '/_authenticated/momentum'
    | '/_authenticated/notifications'
    | '/_authenticated/review'
    | '/_authenticated/settings'
    | '/_authenticated/stats'
    | '/_authenticated/today'
    | '/_authenticated/upcoming'
    | '/_authenticated/voice'
    | '/auth/check-email'
    | '/auth/forgot-password'
    | '/auth/google-onetap'
    | '/auth/login'
    | '/auth/reset-password'
    | '/auth/signup'
    | '/c/$token'
    | '/goals/$goalId'
    | '/goals/new'
    | '/oauth/authorize'
    | '/oauth/consent'
    | '/onboarding/paywall'
    | '/share/$goalId'
    | '/upgrade/success'
    | '/_authenticated/action/follow'
    | '/_authenticated/action/start-story'
    | '/_authenticated/coaching/$clientId'
    | '/_authenticated/coaching/library'
    | '/_authenticated/coaching/plans'
    | '/_authenticated/groves/$groveId'
    | '/_authenticated/habits/$habitId'
    | '/_authenticated/onboarding/intake'
    | '/_authenticated/onboarding/user-profile'
    | '/_authenticated/templates/$templateId'
    | '/api/calendar/callback'
    | '/api/fitness/callback'
    | '/api/gmail/callback'
    | '/api/instagram/callback'
    | '/goals/new/preview'
    | '/goals/new/questions'
    | '/groves/join/$code'
    | '/groves/request/$slug'
    | '/_authenticated/coaching/'
    | '/_authenticated/goals/'
    | '/_authenticated/groves/'
    | '/_authenticated/templates/'
    | '/goals/new/'
    | '/_authenticated/friends/goals/$goalId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  TryRoute: typeof TryRoute
  CTokenRoute: typeof CTokenRoute
  GoalsGoalIdRoute: typeof GoalsGoalIdRoute
  GoalsNewRoute: typeof GoalsNewRouteWithChildren
  OauthAuthorizeRoute: typeof OauthAuthorizeRoute
  OauthConsentRoute: typeof OauthConsentRoute
  OnboardingPaywallRoute: typeof OnboardingPaywallRoute
  ShareGoalIdRoute: typeof ShareGoalIdRoute
  UpgradeSuccessRoute: typeof UpgradeSuccessRoute
  ApiCalendarCallbackRoute: typeof ApiCalendarCallbackRoute
  ApiFitnessCallbackRoute: typeof ApiFitnessCallbackRoute
  ApiGmailCallbackRoute: typeof ApiGmailCallbackRoute
  ApiInstagramCallbackRoute: typeof ApiInstagramCallbackRoute
  GrovesJoinCodeRoute: typeof GrovesJoinCodeRoute
  GrovesRequestSlugRoute: typeof GrovesRequestSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/try': {
      id: '/try'
      path: '/try'
      fullPath: '/try'
      preLoaderRoute: typeof TryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade/success': {
      id: '/upgrade/success'
      path: '/upgrade/success'
      fullPath: '/upgrade/success'
      preLoaderRoute: typeof UpgradeSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$goalId': {
      id: '/share/$goalId'
      path: '/share/$goalId'
      fullPath: '/share/$goalId'
      preLoaderRoute: typeof ShareGoalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding/paywall': {
      id: '/onboarding/paywall'
      path: '/onboarding/paywall'
      fullPath: '/onboarding/paywall'
      preLoaderRoute: typeof OnboardingPaywallRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/consent': {
      id: '/oauth/consent'
      path: '/oauth/consent'
      fullPath: '/oauth/consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/authorize': {
      id: '/oauth/authorize'
      path: '/oauth/authorize'
      fullPath: '/oauth/authorize'
      preLoaderRoute: typeof OauthAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goals/new': {
      id: '/goals/new'
      path: '/goals/new'
      fullPath: '/goals/new'
      preLoaderRoute: typeof GoalsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goals/$goalId': {
      id: '/goals/$goalId'
      path: '/goals/$goalId'
      fullPath: '/goals/$goalId'
      preLoaderRoute: typeof GoalsGoalIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$token': {
      id: '/c/$token'
      path: '/c/$token'
      fullPath: '/c/$token'
      preLoaderRoute: typeof CTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/google-onetap': {
      id: '/auth/google-onetap'
      path: '/google-onetap'
      fullPath: '/auth/google-onetap'
      preLoaderRoute: typeof AuthGoogleOnetapRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/check-email': {
      id: '/auth/check-email'
      path: '/check-email'
      fullPath: '/auth/check-email'
      preLoaderRoute: typeof AuthCheckEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/voice': {
      id: '/_authenticated/voice'
      path: '/voice'
      fullPath: '/voice'
      preLoaderRoute: typeof AuthenticatedVoiceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/upcoming': {
      id: '/_authenticated/upcoming'
      path: '/upcoming'
      fullPath: '/upcoming'
      preLoaderRoute: typeof AuthenticatedUpcomingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/today': {
      id: '/_authenticated/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AuthenticatedTodayRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/stats': {
      id: '/_authenticated/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof AuthenticatedStatsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/review': {
      id: '/_authenticated/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AuthenticatedReviewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/momentum': {
      id: '/_authenticated/momentum'
      path: '/momentum'
      fullPath: '/momentum'
      preLoaderRoute: typeof AuthenticatedMomentumRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/leaderboard': {
      id: '/_authenticated/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof AuthenticatedLeaderboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/journal': {
      id: '/_authenticated/journal'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof AuthenticatedJournalRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inbox': {
      id: '/_authenticated/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthenticatedInboxRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/explore': {
      id: '/_authenticated/explore'
      path: '/explore'
      fullPath: '/explore'
      preLoaderRoute: typeof AuthenticatedExploreRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/everyday': {
      id: '/_authenticated/everyday'
      path: '/everyday'
      fullPath: '/everyday'
      preLoaderRoute: typeof AuthenticatedEverydayRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/discover': {
      id: '/_authenticated/discover'
      path: '/discover'
      fullPath: '/discover'
      preLoaderRoute: typeof AuthenticatedDiscoverRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/goals/new/': {
      id: '/goals/new/'
      path: '/'
      fullPath: '/goals/new/'
      preLoaderRoute: typeof GoalsNewIndexRouteImport
      parentRoute: typeof GoalsNewRoute
    }
    '/_authenticated/templates/': {
      id: '/_authenticated/templates/'
      path: '/templates'
      fullPath: '/templates/'
      preLoaderRoute: typeof AuthenticatedTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groves/': {
      id: '/_authenticated/groves/'
      path: '/groves'
      fullPath: '/groves/'
      preLoaderRoute: typeof AuthenticatedGrovesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/goals/': {
      id: '/_authenticated/goals/'
      path: '/goals'
      fullPath: '/goals/'
      preLoaderRoute: typeof AuthenticatedGoalsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coaching/': {
      id: '/_authenticated/coaching/'
      path: '/coaching'
      fullPath: '/coaching/'
      preLoaderRoute: typeof AuthenticatedCoachingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/groves/request/$slug': {
      id: '/groves/request/$slug'
      path: '/groves/request/$slug'
      fullPath: '/groves/request/$slug'
      preLoaderRoute: typeof GrovesRequestSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/groves/join/$code': {
      id: '/groves/join/$code'
      path: '/groves/join/$code'
      fullPath: '/groves/join/$code'
      preLoaderRoute: typeof GrovesJoinCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/goals/new/questions': {
      id: '/goals/new/questions'
      path: '/questions'
      fullPath: '/goals/new/questions'
      preLoaderRoute: typeof GoalsNewQuestionsRouteImport
      parentRoute: typeof GoalsNewRoute
    }
    '/goals/new/preview': {
      id: '/goals/new/preview'
      path: '/preview'
      fullPath: '/goals/new/preview'
      preLoaderRoute: typeof GoalsNewPreviewRouteImport
      parentRoute: typeof GoalsNewRoute
    }
    '/api/instagram/callback': {
      id: '/api/instagram/callback'
      path: '/api/instagram/callback'
      fullPath: '/api/instagram/callback'
      preLoaderRoute: typeof ApiInstagramCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/gmail/callback': {
      id: '/api/gmail/callback'
      path: '/api/gmail/callback'
      fullPath: '/api/gmail/callback'
      preLoaderRoute: typeof ApiGmailCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/fitness/callback': {
      id: '/api/fitness/callback'
      path: '/api/fitness/callback'
      fullPath: '/api/fitness/callback'
      preLoaderRoute: typeof ApiFitnessCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api/calendar/callback': {
      id: '/api/calendar/callback'
      path: '/api/calendar/callback'
      fullPath: '/api/calendar/callback'
      preLoaderRoute: typeof ApiCalendarCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/templates/$templateId': {
      id: '/_authenticated/templates/$templateId'
      path: '/templates/$templateId'
      fullPath: '/templates/$templateId'
      preLoaderRoute: typeof AuthenticatedTemplatesTemplateIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding/user-profile': {
      id: '/_authenticated/onboarding/user-profile'
      path: '/onboarding/user-profile'
      fullPath: '/onboarding/user-profile'
      preLoaderRoute: typeof AuthenticatedOnboardingUserProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding/intake': {
      id: '/_authenticated/onboarding/intake'
      path: '/onboarding/intake'
      fullPath: '/onboarding/intake'
      preLoaderRoute: typeof AuthenticatedOnboardingIntakeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/habits/$habitId': {
      id: '/_authenticated/habits/$habitId'
      path: '/habits/$habitId'
      fullPath: '/habits/$habitId'
      preLoaderRoute: typeof AuthenticatedHabitsHabitIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/groves/$groveId': {
      id: '/_authenticated/groves/$groveId'
      path: '/groves/$groveId'
      fullPath: '/groves/$groveId'
      preLoaderRoute: typeof AuthenticatedGrovesGroveIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coaching/plans': {
      id: '/_authenticated/coaching/plans'
      path: '/coaching/plans'
      fullPath: '/coaching/plans'
      preLoaderRoute: typeof AuthenticatedCoachingPlansRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coaching/library': {
      id: '/_authenticated/coaching/library'
      path: '/coaching/library'
      fullPath: '/coaching/library'
      preLoaderRoute: typeof AuthenticatedCoachingLibraryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/coaching/$clientId': {
      id: '/_authenticated/coaching/$clientId'
      path: '/coaching/$clientId'
      fullPath: '/coaching/$clientId'
      preLoaderRoute: typeof AuthenticatedCoachingClientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/action/start-story': {
      id: '/_authenticated/action/start-story'
      path: '/action/start-story'
      fullPath: '/action/start-story'
      preLoaderRoute: typeof AuthenticatedActionStartStoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/action/follow': {
      id: '/_authenticated/action/follow'
      path: '/action/follow'
      fullPath: '/action/follow'
      preLoaderRoute: typeof AuthenticatedActionFollowRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/friends/goals/$goalId': {
      id: '/_authenticated/friends/goals/$goalId'
      path: '/friends/goals/$goalId'
      fullPath: '/friends/goals/$goalId'
      preLoaderRoute: typeof AuthenticatedFriendsGoalsGoalIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDiscoverRoute: typeof AuthenticatedDiscoverRoute
  AuthenticatedEverydayRoute: typeof AuthenticatedEverydayRoute
  AuthenticatedExploreRoute: typeof AuthenticatedExploreRoute
  AuthenticatedInboxRoute: typeof AuthenticatedInboxRoute
  AuthenticatedJournalRoute: typeof AuthenticatedJournalRoute
  AuthenticatedLeaderboardRoute: typeof AuthenticatedLeaderboardRoute
  AuthenticatedMomentumRoute: typeof AuthenticatedMomentumRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedReviewRoute: typeof AuthenticatedReviewRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedStatsRoute: typeof AuthenticatedStatsRoute
  AuthenticatedTodayRoute: typeof AuthenticatedTodayRoute
  AuthenticatedUpcomingRoute: typeof AuthenticatedUpcomingRoute
  AuthenticatedVoiceRoute: typeof AuthenticatedVoiceRoute
  AuthenticatedActionFollowRoute: typeof AuthenticatedActionFollowRoute
  AuthenticatedActionStartStoryRoute: typeof AuthenticatedActionStartStoryRoute
  AuthenticatedCoachingClientIdRoute: typeof AuthenticatedCoachingClientIdRoute
  AuthenticatedCoachingLibraryRoute: typeof AuthenticatedCoachingLibraryRoute
  AuthenticatedCoachingPlansRoute: typeof AuthenticatedCoachingPlansRoute
  AuthenticatedGrovesGroveIdRoute: typeof AuthenticatedGrovesGroveIdRoute
  AuthenticatedHabitsHabitIdRoute: typeof AuthenticatedHabitsHabitIdRoute
  AuthenticatedOnboardingIntakeRoute: typeof AuthenticatedOnboardingIntakeRoute
  AuthenticatedOnboardingUserProfileRoute: typeof AuthenticatedOnboardingUserProfileRoute
  AuthenticatedTemplatesTemplateIdRoute: typeof AuthenticatedTemplatesTemplateIdRoute
  AuthenticatedCoachingIndexRoute: typeof AuthenticatedCoachingIndexRoute
  AuthenticatedGoalsIndexRoute: typeof AuthenticatedGoalsIndexRoute
  AuthenticatedGrovesIndexRoute: typeof AuthenticatedGrovesIndexRoute
  AuthenticatedTemplatesIndexRoute: typeof AuthenticatedTemplatesIndexRoute
  AuthenticatedFriendsGoalsGoalIdRoute: typeof AuthenticatedFriendsGoalsGoalIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDiscoverRoute: AuthenticatedDiscoverRoute,
  AuthenticatedEverydayRoute: AuthenticatedEverydayRoute,
  AuthenticatedExploreRoute: AuthenticatedExploreRoute,
  AuthenticatedInboxRoute: AuthenticatedInboxRoute,
  AuthenticatedJournalRoute: AuthenticatedJournalRoute,
  AuthenticatedLeaderboardRoute: AuthenticatedLeaderboardRoute,
  AuthenticatedMomentumRoute: AuthenticatedMomentumRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedReviewRoute: AuthenticatedReviewRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedStatsRoute: AuthenticatedStatsRoute,
  AuthenticatedTodayRoute: AuthenticatedTodayRoute,
  AuthenticatedUpcomingRoute: AuthenticatedUpcomingRoute,
  AuthenticatedVoiceRoute: AuthenticatedVoiceRoute,
  AuthenticatedActionFollowRoute: AuthenticatedActionFollowRoute,
  AuthenticatedActionStartStoryRoute: AuthenticatedActionStartStoryRoute,
  AuthenticatedCoachingClientIdRoute: AuthenticatedCoachingClientIdRoute,
  AuthenticatedCoachingLibraryRoute: AuthenticatedCoachingLibraryRoute,
  AuthenticatedCoachingPlansRoute: AuthenticatedCoachingPlansRoute,
  AuthenticatedGrovesGroveIdRoute: AuthenticatedGrovesGroveIdRoute,
  AuthenticatedHabitsHabitIdRoute: AuthenticatedHabitsHabitIdRoute,
  AuthenticatedOnboardingIntakeRoute: AuthenticatedOnboardingIntakeRoute,
  AuthenticatedOnboardingUserProfileRoute:
    AuthenticatedOnboardingUserProfileRoute,
  AuthenticatedTemplatesTemplateIdRoute: AuthenticatedTemplatesTemplateIdRoute,
  AuthenticatedCoachingIndexRoute: AuthenticatedCoachingIndexRoute,
  AuthenticatedGoalsIndexRoute: AuthenticatedGoalsIndexRoute,
  AuthenticatedGrovesIndexRoute: AuthenticatedGrovesIndexRoute,
  AuthenticatedTemplatesIndexRoute: AuthenticatedTemplatesIndexRoute,
  AuthenticatedFriendsGoalsGoalIdRoute: AuthenticatedFriendsGoalsGoalIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface AuthRouteChildren {
  AuthCheckEmailRoute: typeof AuthCheckEmailRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthGoogleOnetapRoute: typeof AuthGoogleOnetapRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCheckEmailRoute: AuthCheckEmailRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthGoogleOnetapRoute: AuthGoogleOnetapRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface GoalsNewRouteChildren {
  GoalsNewPreviewRoute: typeof GoalsNewPreviewRoute
  GoalsNewQuestionsRoute: typeof GoalsNewQuestionsRoute
  GoalsNewIndexRoute: typeof GoalsNewIndexRoute
}

const GoalsNewRouteChildren: GoalsNewRouteChildren = {
  GoalsNewPreviewRoute: GoalsNewPreviewRoute,
  GoalsNewQuestionsRoute: GoalsNewQuestionsRoute,
  GoalsNewIndexRoute: GoalsNewIndexRoute,
}

const GoalsNewRouteWithChildren = GoalsNewRoute._addFileChildren(
  GoalsNewRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  TryRoute: TryRoute,
  CTokenRoute: CTokenRoute,
  GoalsGoalIdRoute: GoalsGoalIdRoute,
  GoalsNewRoute: GoalsNewRouteWithChildren,
  OauthAuthorizeRoute: OauthAuthorizeRoute,
  OauthConsentRoute: OauthConsentRoute,
  OnboardingPaywallRoute: OnboardingPaywallRoute,
  ShareGoalIdRoute: ShareGoalIdRoute,
  UpgradeSuccessRoute: UpgradeSuccessRoute,
  ApiCalendarCallbackRoute: ApiCalendarCallbackRoute,
  ApiFitnessCallbackRoute: ApiFitnessCallbackRoute,
  ApiGmailCallbackRoute: ApiGmailCallbackRoute,
  ApiInstagramCallbackRoute: ApiInstagramCallbackRoute,
  GrovesJoinCodeRoute: GrovesJoinCodeRoute,
  GrovesRequestSlugRoute: GrovesRequestSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
